// extracted by mini-css-extract-plugin
module.exports = {"groupWrapper":"Group_groupWrapper__1pYRz","searching":"Group_searching__38RzF"};